// extracted by mini-css-extract-plugin
export var bodyRow = "_d3-d";
export var cardColumns = "_d3-e";
export var ellipsesOverflow = "_d3-2";
export var flatBottomCorners = "_d3-3";
export var flatTopCorners = "_d3-4";
export var headerActionsDropdown = "_d3-f";
export var headerBottomRow = "_d3-c";
export var headerTopRow = "_d3-b";
export var orderDetailsWrapper = "_d3-0";
export var orderInfoContainer = "_d3-1";
export var productDetails = "_d3-9";
export var productImage = "_d3-5";
export var responsiveTable = "_d3-8";
export var shipmentContainer = "_d3-a";
export var tableBottomLeft = "_d3-6";
export var tableBottomRight = "_d3-7";
export var trackingLink = "_d3-g";